export default "__VITE_ASSET__Zla_$7q___"